import ServiceBase from 'services/ServiceBase'

class SupportedTimezonesApiClient extends ServiceBase {
  list = () => this.request({
    path: '/v2/supported_timezones',
  })
}

export default SupportedTimezonesApiClient
